<template>
  <v-content pa-0>
    <Header></Header>
    <div
      style="position: relative;display: flex;justify-content: center;align-items: center"
      :style="$vuetify.breakpoint.mdAndUp ? {'padding-top': '88px'}:{}"
    >
      <img
        style="width: 100%"
        v-if="$vuetify.breakpoint.smAndDown"
        :src="require('../assets/bg-cover/mobile-research&report.png')"
      />
      <img
        style="width: 100%"
        v-else
        :src="require('../assets/bg-cover/desktop-research&report.png')"
      />
    </div>
    <v-content style="padding-top: 25px;" class="px-3">
      <div class="text-left mt-3">
        <div v-if="language=='en'" v-html="description.en"></div>
        <div v-if="language=='th'" v-html="description.th"></div>
      </div>
      <template v-if="article!=null">
<!--        <v-layout row justify-center id="article-section">-->
          <v-flex >
            <div class="row text-center">
              <v-layout column :class="{ 'column':$vuetify.breakpoint.smAndDown }">
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-row class="pt-5">
                      <v-col cols="12" sm="12" md="3"   lg="3" xl="2" style="text-align: center">
                        <v-sheet rounded="lg">
                          <v-layout justify-center mt-3 mb-5 class="coloredTxt"
                                    :class="{'column':$vuetify.breakpoint.smAndDown}">
                            <v-row>
                              <v-col cols="10" offset="1">
                                <v-flex shrink
                                        :class="{'mx-7':$vuetify.breakpoint.smAndDown,'mr-3':$vuetify.breakpoint.mdAndUp}">
                                  <v-select v-model="selectedCategory"
                                            :items="industries"
                                            color="#FF5100"
                                            :label="$t('industryCategory')"
                                            @change="onIndustryChanged"
                                            outlined
                                  ></v-select>
                                </v-flex>
                              </v-col>
                              <v-col cols="10" offset="1">
                                <v-flex shrink
                                        :class="{'mx-7':$vuetify.breakpoint.smAndDown,'mr-3':$vuetify.breakpoint.mdAndUp}">
                                  <v-text-field clearable v-model="keyword" outlined :label="$t('keyword')" color="#FF5100"></v-text-field>
                                </v-flex>
                              </v-col>
                              <v-col cols="10" offset="1">
                                <v-flex shrink
                                        :class="{'ml-3':$vuetify.breakpoint.mdAndUp,'mr-10':$vuetify.breakpoint.mdAndUp,}">
                                  <div :class="{'pt-3':$vuetify.breakpoint.mdAndUp}" @click="onSearchClicked">
                                    <v-btn class="white--text" style="width: 100px" color="#FF5100">{{$t('search')}}</v-btn>
                                  </div>
                                </v-flex>
                              </v-col>
                            </v-row>

                          </v-layout>
                        </v-sheet>
                      </v-col>
                      <v-col cols="12" sm="12" md="9"  lg="9" xl="8" >
<!--                        <v-row  >-->
<!--                          <v-col cols="12" sm="12" md="10" lg="12" xl="12">-->
<!--                            <v-layout justify-start >-->
<!--                              <v-flex shrink class="icons">-->
<!--                                <a :href="`https://www.facebook.com/sharer/sharer.php?u=`+shareUrl" target="_blank">-->
<!--                                  <img class="icon" :src="require('../assets/icon/facebook.png')" />-->
<!--                                </a>-->
<!--                                <button :class="{ 'mt-3':$vuetify.breakpoint.mdAndUp }" class="ml-2" type="button" v-clipboard:copy="shareUrl">-->
<!--                                  <v-tooltip bottom>-->
<!--                                    <template v-slot:activator="{ on }">-->
<!--                                      <img class="icon" :src="require('../assets/icon/link.png')" v-on="on" />-->
<!--                                    </template>-->
<!--                                    <span>Copy</span>-->
<!--                                  </v-tooltip>-->
<!--                                </button>-->
<!--                              </v-flex>-->
<!--                            </v-layout>-->
<!--                          </v-col>-->
<!--                        </v-row>-->

                        <span v-if="!this.search">
                          <v-sheet rounded="lg" >
                          <v-row >
                            <v-col cols="12" sm="12" md="10"   lg="5" xl="4">
                              <v-flex  class="text-xl-left text-md-center text-sm-center">
                                <img
                                    style="max-width: 680px; max-height: 680px"
                                    class="img_cover_path"
                                    :src=" img"
                                />
                              </v-flex>
                            </v-col>
                            <v-col cols="12" sm="12" md="10"   lg="5" xl="8">
                              <v-flex  class="text-xl-left text-lg-left text-md-center text-sm-center">
                                <img :src="http+`/`+industries[article.category_id - 21].icon_path" width="20%" height="auto">
                                <h2 class="mb-3" style="color: #FF5100; font-weight: bold;">Creative Industry Database: {{article.category_name}}</h2>
                                  <template v-if="language=='en' && article[`intro_en`] == null">
                                    <div class="mt-5 ">{{article[`intro_th`]}}</div>
                                  </template>
                                  <template v-else-if="language=='th' && article['intro_th'] == null">
                                     <div class="mt-5 ">{{article[`intro_en`]}}</div>
                                  </template>
                                  <template v-else>
                                     <div class="mt-5 ">{{article[`intro_${language}`]}}</div>
                                  </template>
<!--                                <div class="mt-5 ">{{article[`intro_${language}`]}}</div>-->
<!--                                 <v-layout >-->
<!--                              <v-flex shrink class="icons">-->
                                <a :href="`https://www.facebook.com/sharer/sharer.php?u=`+shareUrl" target="_blank">
                                  <img class="icon" :src="require('../assets/icon/facebook.png')" width="30px" height="30px" />
                                </a>
                                <button :class="{ 'mt-3':$vuetify.breakpoint.mdAndUp }" class="ml-2" type="button" v-clipboard:copy="shareUrl">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <img class="icon" :src="require('../assets/icon/link.png')" width="30px" height="30px" v-on="on" />
                                    </template>
                                    <span>Copy</span>
                                  </v-tooltip>
                                </button>
<!--                              </v-flex>-->
<!--                            </v-layout>-->
                              </v-flex>
                            </v-col>
                            <v-col cols="12" sm="12" md="10" lg="10" xl="12" >
                                <template v-if="language == 'en' && article[`detail_en`] == null || article[`detail_en`] == ''">
                                  <div  class="text-left detailArticle" v-html="article[`detail_th`]"></div>
                                </template>
                                <template v-else-if="language == 'th' && article['detail_th'] == null || article[`detail_th`] == ''">
                                  <div  class="text-left detailArticle" v-html="article[`detail_en`]"></div>
                                </template>
                                <template v-else>
                                  <div  class="text-left detailArticle" v-html="article[`detail_${language}`]"></div>
                                </template>
<!--                              <div id="detailArticle" class="text-left" v-html="article[`detail_${language}`]"></div>-->
                            </v-col>

                          </v-row>


                        </v-sheet>
                          <hr/>
                        </span>
                        <span v-if="this.search">
                          <v-flex xs12 lg11 v-if="activeArticles">
                              <ReportGroup group="report" :list="activeArticles"></ReportGroup>
                          </v-flex>
                           <span v-else>
                            <v-flex mb-7>No article found.</v-flex>
                           </span>
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
              </v-layout>
<!--              <div id="detailArticle" class="mt-5 text-left" v-html="article[`detail_${language}`]"></div>-->

            </div>
          </v-flex>
        <hr class="divider" />
<!--        </v-layout>-->
        <div class="my-5">
          <h2
              class="mb-3 text-center text-uppercase"
              style="color: #FF5100; font-weight: bold;"
          >{{$t('related-research-report')}}</h2>
        </div>
        <v-layout justify-center>
          <v-flex xs12 v-if="moreArticles.length > 0">
            <ReportGroup group="overview" :list="moreArticles"></ReportGroup>
          </v-flex>
          <v-flex xs12 pa-12 v-else>
            {{$t('no-related-research-report')}}
          </v-flex>
        </v-layout>
      </template>
    </v-content>
    <Footer></Footer>
  </v-content>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ReportGroup from "../components/ReportGroup";
import {domain, url} from "../services/Constants";
import Service from "../services";

export default {
  props: ["id"],
  metaInfo () {
    return {
      title: this.article ? this.article[`name_${this.language}`] : null,
      meta: [
        {
          name: 'image',
          content: this.article ? `${domain}/${this.article.img_share_path ? this.article.img_share_path:this.article.img_cover_path}` : null
        },
        {
          name: 'description',
          content: this.article ? this.article[`intro_${this.language}`] : null
        },
        {
          name: 'type',
          content: 'article'
        },
        {
          name: 'url',
          content: 'https://data.cea.or.th' + this.$route.path
        }
      ]
    }
  },
  components: {
    Header,
    Footer,
    ReportGroup
  },
  computed: {
    ...mapState({
      language: state => state.locale.language,
      articleId: function() {
        return this.id;
      },
      researchReportBanner: state => state.banner.researchReportBanner,
      industries: function (state) {
        return [
          {
            value: null,
            text: this.$i18n.t('general.select-industry')
          },
          ...state.industry.industries.map(industry => ({
            value: industry.id,
            text: industry[`name_${state.locale.language}`],
            icon_path: industry.icon_path
          }))
        ]
      },
    })
  },
  data: () => ({
    description: { th: null, en: null },
    search:false,
    article: null,
    moreArticles: [],
    articles: [],
    activeArticles: [],
    url: "",
    http: domain,
    shareUrl: "",
    selectCategory: [],
    selectedCategory: null,
    keyword: "",
    current_page: 0,
    loaded: false,
    chartQty: [],
    has_more: true,
    img:''
  }),
  watch: {
    articleId: function () {
      // for replace current article in this page when changed
      if (this.id != this.article.id) {
        this.initCurrentArticle();
      } else {
        this.$vuetify.goTo('#article-section');
      }
    }
  },
  created() {
    Service.analytics.sendPageView({
      path: this.$route.path
    })
    this.$store.dispatch('banner/onGetAllBanners');
    this.initCurrentArticle()
    this.industries[0].name = this.searchAll;


    this.populateIndustries()
  },
  methods: {
    ...mapActions("industry", ["populateIndustries"]),
    // getMoreArticles(tags) {
    //   let articleTags = [];
    //   for (const t of tags) {
    //     // tags from current article
    //     articleTags.push(t.tag_id);
    //   }
    //   Service.webdata.getArticlesMode('all').then(articles => {
    //     // this twice loop for check related with tags
    //     articles = articles.filter(item => {
    //       for (const t of articleTags) {
    //         for (const x of item.tags) {
    //           if (x.tag_id === t && item.id != this.article.id) {
    //             return item
    //           }
    //         }
    //       }
    //     });
    //     if (articles.length > 0) {
    //       this.moreArticles = articles.map(item => {
    //         return {
    //           ...item,
    //           img_cover_path: domain + '/' + item.img_cover_path
    //         }
    //       });
    //     }
    //   });
    // },
    initCurrentArticle() {
      this.$store.dispatch("article/get", this.id).then(res => {
        console.log("res",res)
        this.article = res
        this.url = window.location.href
        // this.shareUrl = `${domain}article/${this.id}/${this.language}`
        this.shareUrl= `${url}article/detail/${this.id}/`
        // let cover_img_path;
        this.img = res.cover_img_path;
        // get related articles
        // this.getMoreArticles(res.tags);
      });
    },
    onSearchClicked() {

      this.search = true;
      const params = {
        page: 1,
        industry_id: this.selectedCategory
      };
      params[`name_${this.language}`] = this.keyword;
      console.log("params",params)
      Service.webdata.getArticles(params).then(res => {
        this.activeArticles = res.data;
      });
    },
    onIndustryChanged() {
      //TODO load
      if (this.selectedCategory) {
        this.activeArticles = this.articles.filter(x => {
          return x.industry_id === this.selectedCategory;
        });
      } else {
        this.activeArticles = this.articles;
      }
    }
  }
};
</script>
<style lang="scss" scoped>

  .img_cover_path {
    width: 90%;
  }

  .content {
    position: relative;
    width: 100%;
    padding: 10px;
  }

  .detailArticle {
    ::v-deep img {
      width: 100% !important;
    }
  }
  .coloredTxt {
    color: #ff5100;
  }

</style>
